/**
 * Capacitor platform helpers — browser-safe (no native imports at module load).
 */

export function isNativeMobileApp(): boolean {
  try {
    // Dynamic require pattern avoided; Capacitor sets window.Capacitor on native.
    const cap = (window as unknown as { Capacitor?: { isNativePlatform?: () => boolean } }).Capacitor;
    return cap?.isNativePlatform?.() === true;
  } catch {
    return false;
  }
}

export function getMobileDeviceId(): string {
  const key = 'passport_mobile_device_id';
  try {
    const existing = localStorage.getItem(key);
    if (existing && existing.length >= 8) return existing;
    const id =
      typeof crypto !== 'undefined' && crypto.randomUUID
        ? crypto.randomUUID()
        : `dev_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem(key, id);
    return id;
  } catch {
    return `dev_${Date.now()}`;
  }
}

export function navigateToDeepLinkPath(path: string): void {
  const p = path.trim();
  if (!p.startsWith('/')) return;
  window.history.pushState({}, '', p);
  window.dispatchEvent(new PopStateEvent('popstate'));
}
